module.exports = __webpack_public_path__ + "static/media/upload.5316200c.svg";